const Style = {
    root: 'pointer-events-none absolute inset-0 select-none overflow-hidden text-white',
    // Overscanned so a ticket drifting near an edge never uncovers the corner
    // it floated away from.
    frame: 'absolute -inset-[10%]',
    // Placement only. The float animation overwrites `transform` wholesale, so
    // the centring translate has to live on a different element than the
    // motion — hence the wrapper/inner split.
    ticket: 'absolute -translate-x-1/2 -translate-y-1/2',
    ticketMotion: 'motion-safe:animate-ticket-float',
    svg: 'block h-auto w-full',
    outline: 'fill-none stroke-current',
    // Perforation and content rules sit a step lighter than the outline so the
    // stub still separates at this opacity.
    perforation: 'fill-none stroke-current opacity-70 [stroke-dasharray:3_5]',
    rule: 'fill-none stroke-current opacity-50',
};

export default Style;
